import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, Palette } from 'lucide-react';
import { extendedTestimonials, TESTIMONIAL_LABEL } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-cream" data-id="element-71" data-mp="bjcpuncm8pjq">
      <div className="max-w-6xl mx-auto" data-id="element-72" data-mp="gauqfaaq8o46">
        <div className="text-center mb-16" data-id="element-73" data-mp="gbwd6c13uz1q">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-charcoal" data-id="element-74" data-mp="gcpdov9h0sbf">
            What Art Teachers Are Saying
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-75" data-mp="q7zgvmblv5qs">
          {extendedTestimonials.map((t, i) => <motion.figure key={t.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-paper border border-warmgray p-8 rounded-2xl relative flex flex-col h-full" data-id="element-76" data-mp="ub5hadc1e2pc" data-mpi={i}>
              <Quote className="absolute top-6 right-6 text-terracotta/15" size={48} aria-hidden="true" data-id="element-77" data-mp="33zm4voloqqcr" />

              <div className="flex gap-1 text-burnt mb-6" aria-label="5 out of 5 stars" data-id="element-78" data-mp="3vqiiwsjhf11m">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" aria-hidden="true" data-id="element-79" data-mp="3mp26ygd0qqva" data-mpi={j} />)}
              </div>

              <blockquote className="text-charcoal-soft italic mb-8 relative z-10 leading-relaxed flex-grow" data-id="element-80" data-mp="2baf7wu1vq8tm">
                “{t.text}”
              </blockquote>

              <figcaption className="flex items-center gap-4 mt-auto" data-id="element-81" data-mp="26df0oftan00x">
                <div className="w-12 h-12 rounded-full bg-terracotta text-paper flex items-center justify-center shrink-0" data-id="element-82" data-mp="27sr9uhq9egcn">
                  <Palette size={20} aria-hidden="true" data-id="element-83" data-mp="2coydg3v6nfrf" />
                </div>
                <div data-id="element-84" data-mp="1yr9uj1koeip0">
                  <div className="font-bold text-charcoal" data-id="element-85" data-mp="1ytw2v3fe528a">{t.role}</div>
                  <div className="text-xs text-terracotta-dark uppercase tracking-wider" data-id="element-86" data-mp="23ot7ly5n0pfd">
                    {TESTIMONIAL_LABEL}
                  </div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}